import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { axiosGet, axiosPost } from "../../api/Axios";

const initialState: AuthState = {
  user: null,
  isSubmitting: false,
  error: null,
  userProfile: null,
};

// Define the login API call
export const loginApi = createAsyncThunk(
  "auth/login",
  async (credentials: ILoginApi, { rejectWithValue }) => {
    try {
      const response = await axiosPost<ILoginApi, AuthApiResponseDetails>(
        "/auth/login", // Replace with your login endpoint
        credentials
      );
      return response; // Return the user data
    } catch (error) {
      return rejectWithValue(error); // Return the error message
    }
  }
);

// Define the signup API call
export const signupApi = createAsyncThunk(
  "auth/signup",
  async (userDetails: ISignupApi, { rejectWithValue }) => {
    try {
      const response = await axiosPost<ISignupApi, AuthApiResponseDetails>(
        "/auth/signup", // Replace with your signup endpoint
        userDetails
      );
      return response; // Return the user data
    } catch (error) {
      return rejectWithValue(error); // Return the error message
    }
  }
);
// Define the getMyProfile API call
export const getMyProfile = createAsyncThunk(
  "/auth/getMyProfile",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosGet<IUserProfile>("/auth/getMyProfile"); // Replace with your profile endpoint
      return response; // Return the user profile data
    } catch (error) {
      return rejectWithValue(error); // Return the error message
    }
  }
);
// Create the auth slice
const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout(state) {
      state.user = null; // Reset user on logout
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginApi.pending, (state) => {
        state.isSubmitting = true; // Set isSubmitting to true while the request is pending
        state.error = null; // Reset error
      })
      .addCase(loginApi.fulfilled, (state, action) => {
        state.isSubmitting = false;
        state.user = action.payload; // Set the logged-in user
      })
      .addCase(loginApi.rejected, (state, action) => {
        state.isSubmitting = false;
        state.error = action.payload as string; // Set the error message
      })
      .addCase(signupApi.pending, (state) => {
        state.isSubmitting = true; // Set isSubmitting to true while the request is pending
        state.error = null; // Reset error
      })
      .addCase(signupApi.fulfilled, (state, action) => {
        state.isSubmitting = false;
        state.user = action.payload; // Optionally, set the signed-up user
      })
      .addCase(signupApi.rejected, (state, action) => {
        state.isSubmitting = false;
        state.error = action.payload as string; // Set the error message
      })
      .addCase(getMyProfile.pending, (state) => {
        state.isSubmitting = true; // Set isSubmitting to true while the request is pending
        state.error = null; // Reset error
      })
      .addCase(getMyProfile.fulfilled, (state, action) => {
        state.isSubmitting = false;
        state.userProfile = action.payload;
      })
      .addCase(getMyProfile.rejected, (state, action) => {
        state.isSubmitting = false;
        state.error = action.payload as string; // Set error message on failed profile fetch
      });
  },
});

// Export actions and reducer
export const { logout } = authSlice.actions;
export default authSlice.reducer;
